import { dfpStatusResponse } from '@interfaces/dfp/response/dfpStatusResponse';

/**
 * A empresa tem Balanço e Faturamento enviados e revisados (`/dfp/status`). Saiu do `DfpComponent` no card 3801 para
 * ele não passar do teto de linhas; o comportamento é o mesmo (as flags vêm todas `true` do backend, ver README).
 */
export function hasReviewedStatements(status: dfpStatusResponse): boolean {
  return (
    status.balanceSheetSent &&
    status.revenueStatementSent &&
    status.balanceSheetReviewed &&
    status.revenueStatementReviewed
  );
}
